import { render, staticRenderFns } from "./TopPlatorms.vue?vue&type=template&id=0be37dd4&scoped=true&"
import script from "./TopPlatorms.vue?vue&type=script&lang=js&"
export * from "./TopPlatorms.vue?vue&type=script&lang=js&"
import style0 from "./TopPlatorms.vue?vue&type=style&index=0&id=0be37dd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be37dd4",
  null
  
)

export default component.exports